import { HttpFetchClient } from "../../lib/httpWexClient";
import { useParams } from "react-router-dom";

export class WexApiError extends Error {
  constructor(message, errorType, httpCode = null, extraContent = null) {
    super(message);
    this.name = "WexApiError";
    this.httpCode = httpCode;
    this.errorType = errorType;
    this.extraContent = extraContent;
  }
}

const useWexClient = () => {
  const { id } = useParams();

  const WEr4u_URL = process.env.REACT_APP_API_URL;
  const TUNNEL_URL = "https://rnd3nxqq-5500.usw3.devtunnels.ms/";
  const TEST = process.env.REACT_APP_TEST_URL;
  const SAAS_URL = process.env.REACT_APP_SAAS_URL;

  const WEX_API_URL = SAAS_URL; // Cambia a WEr4u_URL para producción
  const KPI_API_URL = process.env.REACT_APP_API_URL;
  const GINA_API_URL = process.env.REACT_APP_GINA_API_URL;
  const PRE_BACK_URL = process.env.REACT_APP_PRE_BACK_URL;

  const clientKpis = HttpFetchClient(KPI_API_URL);
  const clientFetch = HttpFetchClient(WEX_API_URL);
  const clientGina = HttpFetchClient(GINA_API_URL);
  const clientBlaster = HttpFetchClient(PRE_BACK_URL);
  const clientTunnel = HttpFetchClient(TUNNEL_URL);

  const getGinaAgentsOnline = async () => {
    const path = "api/get-agents-online";

    const response = await clientGina.get(path);
    return response;
  };

  //********************************
  // API OSMR
  // **************************** */
  const getRoute = async (body = {}) => {
    try {
      const path = "api/navigation/route";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al obtener la ruta:", err);
      throw err;
    }
  };

  const geocodingSearch = async (body = {}) => {
    try {
      const path = "api/geocoding/search";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al realizar la búsqueda de geocodificación:", err);
      throw err;
    }
  };

  const geocodingReverse = async (body = {}) => {
    try {
      const path = "api/geocoding/reverse";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error(
        "Error al realizar la búsqueda inversa de geocodificación:",
        err,
      );
      throw err;
    }
  };

  const login = async (user, password) => {
    const path = "login";

    const dataObjt = {
      user,
      password,
    };

    const response = await clientFetch.post(path, dataObjt);

    return response;
  };

  const forgotPassword = async (user) => {
    try {
      const path = "api/send-verify-code";
      const response = await clientFetch.post(path, {
        user,
      });
      return response;
    } catch (err) {
      console.error("Error al solicitar recuperación:", err);
      throw err;
    }
  };

  const verifyCode = async (user, code) => {
    try {
      const path = "api/verify-code";
      const response = await clientFetch.post(path, {
        user,
        code,
      });
      return response;
    } catch (err) {
      console.error("Error al verificar código:", err);
      throw err;
    }
  };

  const getQueues = async () => {
    const path = `api/detail-service/${id}`;
    const object = {
      idUser: id,
    };

    const response = await clientFetch.post(path, object);
    return response;
  };

  const getListQueues = async (idService = "") => {
    const path = `api/detail-service/${idService}`;
    const response = await clientFetch.post(path);
    return response;
  };

  const getClassifications = async () => {
    const path = `api/get-classifications`;
    const object = {
      idService: id, // se corrigio a idService
    };

    const response = await clientFetch.post(path, object);
    return response;
  };

  const getListClassifications = async (idService = "") => {
    const path = `api/get-classifications`;
    const object = {
      idService: idService,
    };
    const response = await clientFetch.post(path, object);
    return response;
  };

  const getInfoGeneral = async () => {
    const path = `api/generalInformation/${id}`;
    const objet = {
      idUser: id,
    };

    const response = await clientFetch.post(path, objet);
    return response;
  };

  const getAplications = async () => {
    const path = `api/AppsThirdParty/${id}`;
    const objet = {
      idUser: id,
    };

    const response = await clientFetch.post(path, objet);
    return response;
  };

  const getServices = async (idUser = "", status) => {
    const path = "api/services";
    const objet = {
      idUser,
      status,
    };
    const response = await clientFetch.post(path, objet);
    return response;
  };

  const getStatusAgent = async (body = {}) => {
    const path = "api/update-status-user";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getTransferFolio = async (body = {}) => {
    const path = "api/transfer-folio";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getCommisionist = async (body = {}) => {
    const path = "api/enqueue-comisionista";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getCallConsultor = async (body = {}) => {
    const path = "api/call-out-client";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getCallsIntern = async (body = {}) => {
    const path = "make-call";
    const response = await clientGina.post(path, body);
    return response;
  };

  const sendMessageCabin = async (body = {}) => {
    const path = "web/cabin/send-text-message";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getContactsCabin = async (body = {}) => {
    const path = "web/cabin/get-chats";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getConversationCabin = async (body = {}) => {
    const path = "mobile/history-folio-bodie";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const sendWhatsApp = async (body = {}) => {
    try {
      const path = "web/send-whatsapp";

      const response = await clientFetch.post(path, body);

      return response;
    } catch (err) {
      console.error("Error al enviar mensaje por WhatsApp:", err);
      throw err;
    }
  };

  const getFinishOutbound = async (body = {}) => {
    const path = "api/get-end-folios";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getControlStatus = async (body = {}) => {
    const path = "api/get-status-agent";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getRegistersLists = async (body = {}) => {
    const path = "api-mobile/get-customers-for-queue";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const disconnectAgents = async (body = {}) => {
    const path = "api/disconnect-agent";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const finishCall = async (body = {}) => {
    const path = "hang-up-conference";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const finishCallSale = async (body = {}) => {
    const path = "api/hang-up-call";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const closeFolio = async (body = {}) => {
    const path = "api/close-folio";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const closeVisit = async (body = {}) => {
    const path = "visits/close-visit";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const startCall = async (body = {}) => {
    const path = "call-out";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getResponse = async () => {
    const path = `api/quicklyAnswer/${id}`;
    const objet = {
      idUser: id,
    };

    const response = await clientFetch.post(path, objet);
    return response;
  };

  const getCallsForWeek = async (startDate, endDate, serviceId) => {
    const path = `api/callsForWeek`;
    const objet = {
      startDate,
      endDate,
      service: serviceId,
    };

    const response = await clientFetch.post(path, objet);
    return response.calls;
  };

  const createUserMaster = async (body = {}) => {
    const path = "api/create-user-master";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const createService = async (body = {}) => {
    const path = "api/create-service";
    let formdata = new FormData();
    formdata.append("idUser", body.idUser);
    formdata.append("nameCompany", body.nameCompany);
    formdata.append("typeService", body.typeService);
    formdata.append("image", body.image);

    const response = await clientFetch.postFormData(path, formdata);
    return response;
  };

  const createResponse = async (body = {}) => {
    const path = `api/add-quicklyAnswer`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const createText = async (body = {}) => {
    const path = `api/send-text-message`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const createImage = async (
    serviceID,
    image,
    to,
    folio,
    from,
    token,
    idAgent,
  ) => {
    try {
      const path = `api/send-image-message`;
      let formdata = new FormData();

      formdata.append("image", image);
      formdata.append("folio", folio);
      formdata.append("from", from);
      formdata.append("token", token);
      formdata.append("idAgent", idAgent);
      formdata.append("serviceID", serviceID);
      formdata.append("to", to);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en File:", err);
      throw new Error(err);
    }
  };

  const createFiles = async (
    serviceID,
    file,
    to,
    folio,
    from,
    token,
    idAgent,
  ) => {
    try {
      const path = `api/send-file-message`;
      let formdata = new FormData();

      formdata.append("file", file);
      formdata.append("folio", folio);
      formdata.append("from", from);
      formdata.append("token", token);
      formdata.append("idAgent", idAgent);
      formdata.append("serviceID", serviceID);
      formdata.append("to", to);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en File:", err);
      throw new Error(err);
    }
  };

  const getActiveList = async (body = {}) => {
    const path = `api/get-active-list/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getActiveListSMS = async (body = {}) => {
    const path = `api/get-active-list-sms/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const changeQueueQuantum = async (body = {}) => {
    const path = `api/sendToQueue`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getAllList = async (idService = "") => {
    const path = `api/get-active-list/${idService}`;
    const response = await clientFetch.post(path, { active: false });
    return response;
  };

  const getAllListShops = async (idService = "") => {
    const path = `places/get-places-by-service/${idService}`;
    const response = await clientFetch.get(path);
    return response;
  };

  const getVisitsbyPlace = async (body = {}) => {
    const path = `visits/get-visits-by-place`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getAllListSMS = async (idService = "") => {
    const path = `api/get-active-list-sms/${idService}`;
    const response = await clientFetch.post(path, { active: false });
    return response;
  };

  const getFolioGeneral = async (body = {}) => {
    const path = `api/report/detail-by-folio`;
    const response = await clientBlaster.post(path, body);
    return response;
  };

  const getFolioMessages = async (body = {}) => {
    const path = `api/get-messages-by-folio`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getDeleteList = async (body = {}) => {
    const path = `api/change-status-list`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getDeleteResponse = async (body = {}) => {
    const path = `api/delete-quicklyAnswer`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getDeleteClass = async (body = {}) => {
    const path = `api/delete-classifications/`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getAllAgents = async (idService) => {
    const path = `api/agents-registers/${idService}`;
    const response = await clientFetch.post(path);
    return response;
  };

  const createQueue = async (body = {}) => {
    const path = `api/add-queue/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const createClass = async (body = {}) => {
    const path = `api/add-classifications/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getUpdateCRM = async (body = {}) => {
    const path = `api/get-crm/${id}`;

    const response = await clientFetch.get(path, body);
    return response;
  };

  const getAddCRM = async (body = {}) => {
    const path = `api/create-crm/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getDeleteCRM = async (body = {}) => {
    const path = `api/delete-crm/${id}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getQuestionForm = async (idService = "") => {
    const path = `api/get-questions/${idService}`;
    const response = await clientFetch.get(path);
    return response;
  };

  const getListUsersMaster = async () => {
    const path = `api/services/active/admins`;
    const response = await clientFetch.get(path);
    return response;
  };

  const getCreateQuestion = async (idService = "", body = {}) => {
    const path = `api/create-question/${idService}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getAnswersForm = async (idQuestions = "", body = {}) => {
    const path = `api/get-answers/${idQuestions}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getInfoAgents = async (idService, body = {}) => {
    const path = `api/get-info-agent/${idService}`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getListCRM = async (idService) => {
    const path = `api/get-crm/${idService}`;

    const response = await clientFetch.get(path);
    return response;
  };

  const getUpdateAgents = async (body = {}) => {
    const path = `api/updateUser`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getUpdateAnswer = async (body = {}) => {
    const path = `api/update-answerd`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getUpdateIVR = async (body = {}) => {
    const path = `api/updateIvr`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getDeleteAgents = async (body = {}) => {
    const path = `api/deleteUser`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const closeAllFolios = async (body = {}) => {
    const path = `api/close-all-folios`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const getListIVR = async (body = {}) => {
    const path = `api/options-ivr`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const addNewIVR = async (body = {}) => {
    const path = `api/add-ivr`;
    const response = await clientFetch.post(path, body);
    return response;
  };

  const sendCSVFile = async (
    fileInput,
    uriFile = "",
    nameCampaign,
    startDate,
    schedule,
  ) => {
    try {
      const path = `api/upload-XLSX/${id}`;
      let formdata = new FormData();

      formdata.append("archivoXLSX", fileInput, uriFile);
      formdata.append("nameCampaign", nameCampaign);
      formdata.append("startDate", startDate);
      formdata.append("schedule", schedule);

      const response = await clientBlaster.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendCSVFile:", err);
      throw new Error(err);
    }
  };

  const sendSMS = async (
    fileInput,
    urifile = "",
    nameCampaign,
    startDate,
    schedule,
  ) => {
    try {
      const path = `api/send-sms/${id}`;
      let formdata = new FormData();

      formdata.append("archivoXLSX", fileInput, urifile);
      formdata.append("nameCampaign", nameCampaign);
      formdata.append("startDate", startDate);
      formdata.append("schedule", schedule);

      const response = await clientBlaster.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendSMS:", err);
      throw new Error(err);
    }
  };

  const sendCSVLocation = async (
    fileInput,
    uriFile = "",
    nameCampaign,
    idAgent,
    address,
  ) => {
    try {
      const path = `api/upload-csv-location`;
      let formdata = new FormData();

      formdata.append("file", fileInput, uriFile);
      formdata.append("idService", id);
      formdata.append("idAgent", idAgent);
      formdata.append("nameOutbound", nameCampaign);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendCSV:", err);
      throw new Error(err);
    }
  };

  const sendCSVOutbound = async (
    fileInput,
    uriFile = "",
    nameCampaign,
    idAgent,
    queue,
  ) => {
    try {
      const path = `api/upload-csv-oubtound`;
      let formdata = new FormData();

      formdata.append("file", fileInput, uriFile);
      formdata.append("idService", id);
      formdata.append("idUser", idAgent);
      formdata.append("nameOutbound", nameCampaign);
      formdata.append("queue", queue);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendCSV:", err);
      throw new Error(err);
    }
  };

  const getCallsForDate = async (body = {}) => {
    try {
      const path = `api/get-calls`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getFoliosForDate = async (body = {}) => {
    try {
      const path = `api/report/folio-head`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getTokenWorkshop = async (body = {}) => {
    try {
      const path = `visits/valid-token`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getTokenLogin = async (body = {}) => {
    try {
      const path = `visit/get-token-visit`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getClassificationsForDate = async (body = {}) => {
    try {
      const path = `api/report/count-classifications-by-service`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getMinutesForDate = async (body = {}) => {
    try {
      const path = `api/report/consume-for-minutes`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getCountCalls = async (body = {}) => {
    try {
      const path = `api/get-count-calls`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getFailedCalls = async (body = {}) => {
    try {
      const path = `report/consume-calls-unsuccesful`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getVoicemailCalls = async (body = {}) => {
    try {
      const path = `report/consume-calls-voicemail`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getOneByOneCalls = async (body = {}) => {
    try {
      const path = `report/consume/one-by-one`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getAvailableAgents = async (body = {}) => {
    try {
      const path = `mobile/get-agents-by-status`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getSuccessCalls = async (body = {}) => {
    try {
      const path = `report/consume-calls-succes`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getCountCallsForList = async (body = {}) => {
    try {
      const path = `api/count-calls-blaster`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getCallsByStatus = async (body = {}) => {
    try {
      const path = `api/count-calls-for-status`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getSMSByStatus = async (body = {}) => {
    try {
      const path = `api/count-SMS-for-status`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getInfoByList = async (body = {}, idService = "") => {
    try {
      const path = `api/get-calls-blaster/${idService}`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getInfoByListSMS = async (body = {}, idService = "") => {
    try {
      const path = `api/get-sms-blaster/${idService}`;
      const response = await clientBlaster.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getIVRCalls = async (body = {}) => {
    try {
      const path = `api/get-calls-ivr`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getIVRDuration = async (body = {}) => {
    try {
      const path = `api/ivr-call-duration`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const instancePostResponse = async (baseURL, method) => {
    const request = buildReqestFormData(baseURL, method);
    const response = await fetch(request);
    const data = (await response) ? response?.json() : {};

    return data;
  };

  const buildReqestFormData = (baseURL, method) => {
    return new Request(`${baseURL}`, {
      method: method,
      redirect: "follow",
    });
  };

  const getCountries = async () => {
    try {
      const url = process.env.REACT_APP_MONGO_STITCH_URL;
      const response = instancePostResponse(url, "GET");

      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const updateUserNameFetch = async (body = {}) => {
    try {
      const path = `api/update-user-name`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const updatePasswordFetch = async (body = {}) => {
    try {
      const path = "api/update-password";

      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error("Error al actualizar contraseña:", err);
      throw new Error(err);
    }
  };

  const updateServiceStatus = async (body = {}) => {
    try {
      const path = `api/update-status-service`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const countAgentByStatus = async (body = {}) => {
    try {
      const path = `api/count-agents-for-status`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const sendComents = async (body = {}) => {
    try {
      const path = `comment`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getComments = async (body = {}) => {
    try {
      const path = `folio-comments-detailed`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getAllConnectAgents = async (body = {}) => {
    try {
      const path = `api/count-agents-total`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getCostDetailConsume = async (body = {}, idService = "") => {
    try {
      const path = `api/report-detail-consume/${idService}`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getAllListOutbound = async (body = {}, idService = "") => {
    try {
      const path = `api/lists-oubound-calls/${idService}`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getListDetailOutbound = async (idList = "") => {
    try {
      const path = `api/data-lists-oubound-calls/${idList}`;
      const response = await clientFetch.post(path);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getLisOutboundMobile = async (idList = "") => {
    try {
      const path = `api/data-lists-location/${idList}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const sendCSVAgents = async (fileInput, uriFile = "", idService, idAdmin) => {
    try {
      const path = `mobile/create-users`;
      let formdata = new FormData();

      formdata.append("file", fileInput, uriFile); //file
      formdata.append("idService", idService);
      formdata.append("idAdmin", idAdmin);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendCSVFile:", err);
      throw new Error(err);
    }
  };

  const sendCSVAdjusters = async (
    fileInput,
    uriFile = "",
    idService,
    idAdmin,
    serviceType,
  ) => {
    try {
      const path = `api/create-users-bulk`;
      let formdata = new FormData();

      formdata.append("file", fileInput, uriFile); //file
      formdata.append("idService", idService);
      formdata.append("idAdmin", idAdmin);
      formdata.append("serviceType", serviceType);

      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en sendCSVFile:", err);
      throw new Error(err);
    }
  };

  const listasActivas = async (body = {}) => {
    try {
      const path = `api-mobile/get-files-actives`;

      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error en activeList:", err);
      throw new Error(err);
    }
  };

  const locationAgents = async (body = {}) => {
    try {
      const path = `api/get-location`;

      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error en locationAgents:", err);
      throw new Error(err);
    }
  };

  const createForms = async (body = {}) => {
    try {
      const path = `mobile/adjusters/create-incident`;

      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error en Formilario:", err);
      throw new Error(err);
    }
  };

  const locationForAgent = async (body = {}) => {
    try {
      const path = `api/locations-byagent`;

      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error", err);
      throw new Error(err);
    }
  };

  const getTokenKPI = async (service) => {
    const path = `api/get-embed-token`;

    const response = await clientKpis.post(path, { service });
    return response;
  };

  const getOptionsKPI = async (service) => {
    try {
      const path = "api/reports";
      const response = await clientKpis.post(path, { service });
      return response;
    } catch (err) {
      console.error("Error", err);
      throw new Error(err);
    }
  };

  const createServiceMaster = async (body = {}) => {
    const path = "api/create-service-master";
    let formdata = new FormData();
    console.log(" body: ", body);

    formdata.append("nameService", body.nameService);
    formdata.append("typeService", body.typeService);
    formdata.append("idUser", body.idUser);
    formdata.append("phone", body.phoneService);
    formdata.append("messageWelcome", body.messageWelcome);
    formdata.append("avatar", body.avatar);

    const response = await clientFetch.postFormData(path, formdata);
    return response;
  };

  const getAdminsForMaster = async () => {
    try {
      const path = `get-users-by-master`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error("Error en getAdminsForMaster:", err);
      throw new Error(err);
    }
  };

  const getUsersbyService = async (body = {}) => {
    try {
      const path = "api/users/by-service";
      const response = await clientFetch.post(path, body);

      return response;
    } catch (err) {
      console.error("Error en getUsersbyService", err);
      throw new Error(err);
    }
  };

  const updateUserByMaster = async (body = {}) => {
    try {
      const path = "master/update-user";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error en UpdateUserByMaster");
      throw new Error(err);
    }
  };

  const updateServiceByMaster = async (body = {}) => {
    try {
      const path = "api/update-service-data";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error en UpdateServiceByMaster");
      throw new Error(err);
    }
  };

  const AgentsHistoryFolio = async (body = {}) => {
    try {
      const path = "get-history-by-header";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getInfoCRM = async (body = {}) => {
    try {
      const path = "api/info-crm";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getAgentsListCRM = async (idService) => {
    const path = `api/get-crm/${idService}`;

    const response = await clientFetch.get(path);
    return response;
  };

  const ListaDeFolio = async (body = {}) => {
    try {
      const path = "api/get-files-by-service-queue";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const folioCart = async (body = {}) => {
    try {
      const path = "api/get-one-register";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const reopenFolio = async (body = {}) => {
    try {
      const path = "api/requeue-folio";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getFastResponse = async (idService = "") => {
    const path = `api/quicklyAnswer/${idService}`;
    const response = await clientFetch.post(path);
    return response;
  };

  const AgentsUpdateCRM = async (body = {}) => {
    try {
      const path = "api/update-crm-field";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getAudio = async (url) => {
    const path = `reporting-call/download?key=${url}`;

    const response = await clientFetch.get(path);
    return response;
  };

  const updateWelcomeMessage = async (body = {}) => {
    try {
      const path = "api/update-message-welcome";
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error(err);
      throw new Error(err);
    }
  };

  const updateAvatarService = async (body = {}) => {
    try {
      const path = "api/update-image-service";
      let formdata = new FormData();
      formdata.append("serviceId", body.serviceId);
      formdata.append("nameService", body.nameService);
      formdata.append("image", body.image);
      const response = await clientFetch.postFormData(path, formdata);
      return response;
    } catch (err) {
      console.error("Error en updateAvatarService:", err);
      throw err;
    }
  };

  const uploadWorkshop = async (
    fileInput,
    urlFile = "",
    idAssociative,
    idService,
  ) => {
    try {
      const path = "upload-workshops";

      const formData = new FormData();
      formData.append("file", fileInput, urlFile);
      formData.append("idAssociative", idAssociative); // payload._Id
      formData.append("idService", idService); // params

      const response = await clientFetch.postFormData(path, formData);
      return response;
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      throw error;
    }
  };

  const getFilePlaces = async (idService) => {
    try {
      const path = `places/get-file-places/${idService}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (error) {
      console.error("Error al obtener el archivo:", error);
      throw error;
    }
  };

  const downloadFiles = async (key) => {
    try {
      const path = `reporting-call/download?key=${encodeURIComponent(key)}`;
      const response = await clientFetch.get(path);

      console.log("Archivo descargado correctamente:", response);
      return response;
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
      throw error;
    }
  };

  const uploadCsvItems = async (
    fileInput,
    urlFile = "",
    idService,
    idUser,
    nameOutbound,
  ) => {
    try {
      const path = "api/upload-csv-items";

      const formData = new FormData();
      formData.append("file", fileInput, urlFile); // archivo CSV
      formData.append("idService", idService); //  params
      formData.append("idUser", idUser); // payload._id
      formData.append("nameOutbound", nameOutbound); // "Autos a visitar :D"

      const response = await clientFetch.postFormData(path, formData);
      return response;
    } catch (error) {
      console.error("Error al subir el archivo CSV:", error);
      throw error;
    }
  };

  const updateRecordCalls = async (body = {}) => {
    try {
      const path = "master/update-record-calls";
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error(err);
      throw new Error(err);
    }
  };

  const updateCost = async (body = {}) => {
    try {
      const path = "master/update-cost";
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error(err);
      throw new Error(err);
    }
  };

  const getFolioAdjusters = async (body = {}) => {
    try {
      const path = "api/reports/folio-detail";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (error) {
      console.error("Error al obtener el detalle del folio:", error);
      throw error;
    }
  };

  const getConversationByHeader = async (body = {}) => {
    try {
      const path = "web/get-conversation-by-header";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (error) {
      console.error("Error al obtener el detalle del folio:", error);
      throw error;
    }
  };

  const createRegions = async (body = {}) => {
    try {
      const path = "region/create";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getRegions = async (body = {}) => {
    try {
      const path = "region/get-regions";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const updateRegions = async (idRegion, body = {}) => {
    try {
      const path = `region/update/${idRegion}`;
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const updateUser = async (idAsjuster, body = {}) => {
    try {
      const path = `api/updateUser/${idAsjuster}`;
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const usersForRegion = async (body = {}) => {
    try {
      const path = `api/web/users-by-region`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      throw new Error(err);
    }
  };

  const createUser = async (body = {}) => {
    const path = "api/create-user";
    const response = await clientFetch.post(path, body);
    return response;
  };

  const imgForIncident = async (idHeader) => {
    try {
      const path = `web/get-images-incident`;
      const response = await clientFetch.post(path, { idHeader });
      return response;
    } catch (err) {
      console.error("Error al obtener las imágenes del incidente:", err);
      throw new Error(err);
    }
  };

  const createSurvey = async (surveyData = {}) => {
    try {
      const path = "surveys/create-survey";
      const response = await clientFetch.post(path, surveyData);
      return response;
    } catch (err) {
      console.error("Error al crear la encuesta:", err);
      throw new Error(err);
    }
  };

  const getSurveys = async (serviceId) => {
    try {
      const path = `surveys/get-survey/${serviceId}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error("Error al obtener las encuestas:", err);
      throw new Error(err);
    }
  };

  const updateSurvey = async (surveyId, surveyData = {}) => {
    try {
      const path = `surveys/update-survey/${surveyId}`;
      const response = await clientFetch.put(path, surveyData);
      return response;
    } catch (err) {
      console.error("Error al actualizar la encuesta:", err);
      throw new Error(err);
    }
  };

  const getFoliosReports = async (body = {}) => {
    try {
      const path = "web/report-folios";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al obtener el reporte de folios:", err);
      throw new Error(err);
    }
  };

  const getPendingFolios = async (regionId) => {
    try {
      const path = `web/folios/pending/${regionId}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error("error al obtener los folios pendientes por región:", err);
      throw new Error(err);
    }
  };

  const getPendingFoliosBySupervisor = async (supervisorId) => {
    try {
      const path = `web/folios-pending-by-cabin/${supervisorId}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error(
        "error al obtener los folios pendientes por cabin/creator:",
        err,
      );
      throw new Error(err);
    }
  };

  const getAdjustersOnRoad = async (idSupervisor) => {
    try {
      const path = `web/get-status-users/${idSupervisor}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error(
        "error al obtener los ajustadores en camino por región:",
        err,
      );
      throw new Error(err);
    }
  };

  const getResolution = async (visitId) => {
    try {
      const path = `visits/${visitId}/resolution`;
      const response = await clientFetch.get(path, visitId);
      return response;
    } catch (err) {
      console.error("Error al obtener la resolución:", err);
      throw new Error(err);
    }
  };

  const addShifts = async (body = {}) => {
    try {
      const path = `api/shifts/create`;
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al obtener la resolución:", err);
      throw new Error(err);
    }
  };

  const getIncidentsMapReport = async (body = {}) => {
    try {
      const path = "incidents-map-report";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error getIncidentsMapReport:", err);
      throw new Error(err);
    }
  };

  const getIncidentsForHeatmap = async (body = {}) => {
    try {
      console.log("body", body);
      const path = "incidents-list";
      const response = await clientFetch.post(path, body);

      return response;
    } catch (err) {
      console.error("Error en getIncidentsList:", err);
      throw err;
    }
  };

  const getShifts = async (idService) => {
    try {
      const path = `api/shifts/${idService}`;
      const response = await clientFetch.get(path);
      return response;
    } catch (err) {
      console.error("Error al obtener turnos:", err);
      throw new Error(err);
    }
  };

  const updateShifts = async (body = {}) => {
    try {
      const path = `api/shifts/update/${body.idShift}`;
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error("Error al actualizar turnos:", err);
      throw new Error(err);
    }
  };

  const shiftScheduling = async (fileInput, uriFile = "", service) => {
    try {
      const path = `api/shifts/import-users-shifts`;

      const formData = new FormData();

      formData.append("file", fileInput, uriFile);
      formData.append("service", service);

      const response = await clientFetch.postFormData(path, formData);

      return response;
    } catch (err) {
      console.error("Error al importar turnos:", err);
      throw new Error(err);
    }
  };

  const getRegionDetail = async (idSupervisor) => {
    try {
      const path = `detail/regions/${idSupervisor}`;

      const response = await clientFetch.get(path);

      return response;
    } catch (err) {
      console.error("Error al obtener detalle de región:", err);
      throw new Error(err);
    }
  };

  const requestCancellationPin = async (body = {}) => {
    try {
      const path = "api/cancellations/send-code";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al solicitar PIN de cancelación:", err);
      throw err;
    }
  };

  const cancelAssignment = async (body = {}) => {
    try {
      const path = "web/cancel-assignment";
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error("Error al cancelar asignación:", err);
      throw err;
    }
  };

  const requestWhatsAppContact = async (body = {}) => {
    try {
      const path = "whatsapp/contact-request";

      const response = await clientFetch.post(path, body);

      return response;
    } catch (err) {
      console.error("Error al solicitar contacto por WhatsApp:", err);
      throw err;
    }
  };

  const getWhatsAppWindow = async (idUser) => {
    try {
      const path = `users/${idUser}/whatsapp-window`;

      const response = await clientFetch.get(path);

      return response;
    } catch (err) {
      console.error(
        "Error al obtener status de conversacion de WhatsApp:",
        err,
      );
      throw err;
    }
  };

  const markedAdjusters = async (body) => {
    try {
      const path = "marked-adjusters";

      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al marcar ajustador");
      throw err;
    }
  };

  const getBases = async (body = {}) => {
    try {
      const path = "api/get-bases";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al consultar bases");
      throw err;
    }
  };

  const createBase = async (body = {}) => {
    try {
      const path = "api/create-base";
      const response = await clientFetch.post(path, body);
      return response;
    } catch (err) {
      console.error("Error al crear bases");
      throw err;
    }
  };

  const updateBase = async (body = {}) => {
    try {
      const path = "api/update-base";
      const response = await clientFetch.put(path, body);
      return response;
    } catch (err) {
      console.error("Error al actualizar bases");
      throw err;
    }
  };

  return {
    sendSMS,
    getAddCRM,
    getDeleteCRM,
    getUpdateCRM,
    getCountries,
    login,
    forgotPassword,
    verifyCode,
    createUser,
    getServices,
    getQueues,
    getClassifications,
    getInfoGeneral,
    getResponse,
    getAplications,
    getCallsForWeek,
    getUpdateAgents,
    getDeleteAgents,
    sendCSVFile,
    getUpdateIVR,
    getListIVR,
    addNewIVR,
    createResponse,
    getDeleteResponse,
    getDeleteClass,
    createQueue,
    createClass,
    getCallsForDate,
    getCountCalls,
    getActiveList,
    getDeleteList,
    getAllList,
    getIVRCalls,
    getCountCallsForList,
    getListCRM,
    getAllAgents,
    getCallsByStatus,
    getInfoByList,
    getIVRDuration,
    getFolioGeneral,
    getFolioMessages,
    updatePasswordFetch,
    updateUserNameFetch,
    updateServiceStatus,
    createService,
    getActiveListSMS,
    getAllListSMS,
    getInfoByListSMS,
    getSMSByStatus,
    AgentsUpdateCRM,
    getStatusAgent,
    finishCall,
    getFastResponse,
    getAllConnectAgents,
    countAgentByStatus,
    startCall,
    getControlStatus,
    finishCallSale,
    getInfoAgents,
    disconnectAgents,
    getGinaAgentsOnline,
    getCommisionist,
    getCallConsultor,
    getCostDetailConsume,
    getAllListOutbound,
    getListDetailOutbound,
    getQuestionForm,
    getCreateQuestion,
    getAnswersForm,
    getUpdateAnswer,
    createText,
    createImage,
    createFiles,
    changeQueueQuantum,
    getFinishOutbound,
    getCallsIntern,
    closeAllFolios,
    sendCSVLocation,
    sendCSVOutbound,
    sendCSVAgents,
    listasActivas,
    locationAgents,
    locationForAgent,
    createServiceMaster,
    getAdminsForMaster,
    createUserMaster,
    getListUsersMaster,
    getUsersbyService,
    updateUserByMaster,
    updateServiceByMaster,
    getSuccessCalls,
    getFailedCalls,
    getVoicemailCalls,
    getOneByOneCalls,
    getRegistersLists,
    getTokenKPI,
    getOptionsKPI,
    getLisOutboundMobile,
    closeFolio,
    getListClassifications,
    getListQueues,
    getTransferFolio,
    getAgentsListCRM,
    getInfoCRM,
    AgentsHistoryFolio,
    sendComents,
    getComments,
    ListaDeFolio,
    folioCart,
    reopenFolio,
    getFoliosForDate,
    getAudio,
    updateWelcomeMessage,
    updateAvatarService,
    getClassificationsForDate,
    getMinutesForDate,
    updateRecordCalls,
    updateCost,
    getTokenWorkshop,
    getTokenLogin,
    getAllListShops,
    getVisitsbyPlace,
    closeVisit,
    uploadWorkshop,
    getFilePlaces,
    downloadFiles,
    uploadCsvItems,
    sendCSVAdjusters,
    createForms,
    getAvailableAgents,
    sendMessageCabin,
    getContactsCabin,
    getConversationCabin,
    getFolioAdjusters,
    getConversationByHeader,
    getRegions,
    updateRegions,
    createRegions,
    updateUser,
    usersForRegion,
    imgForIncident,
    createSurvey,
    getSurveys,
    updateSurvey,
    getFoliosReports,
    getPendingFolios,
    getAdjustersOnRoad,
    getPendingFoliosBySupervisor,
    getIncidentsForHeatmap,
    getResolution,
    addShifts,
    getShifts,
    updateShifts,
    getIncidentsMapReport,
    shiftScheduling,
    getRegionDetail,
    requestCancellationPin,
    cancelAssignment,
    getRoute,
    sendWhatsApp,
    requestWhatsAppContact,
    getWhatsAppWindow,
    markedAdjusters,
    getBases,
    createBase,
    updateBase,
    geocodingSearch,
    geocodingReverse,
  };
};
export default useWexClient;
